import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b99f4c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "progress-stats-card" }
const _hoisted_2 = { class: "stats-grid" }
const _hoisted_3 = { class: "stat-header" }
const _hoisted_4 = { class: "label-section" }
const _hoisted_5 = { class: "status-label" }
const _hoisted_6 = { class: "count-section" }
const _hoisted_7 = { class: "count" }
const _hoisted_8 = { class: "change-content" }
const _hoisted_9 = {
  key: 0,
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M6 9.5V2.5M6 2.5L2.5 6M6 2.5L9.5 6",
  stroke: "#10B981",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M6 2.5V9.5M6 9.5L2.5 6M6 9.5L9.5 6",
  stroke: "#6B7280",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "progress-bar-wrapper" }

import { computed } from "vue";
import type { PropType } from "vue";
import LingoBadge from "@/modules/main/components/manage/LingoBadgeComponent.vue";
import LingoTooltipIcon from "@/modules/main/components/manage/LingoTooltipIconComponent.vue";

type Stat = {
  status: string;
  label: string;
  count: number;
  percentage: number;
  color?: string;
  tooltip?: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'ProgressStatsCardComponent',
  props: {
  stats: { type: Array as PropType<Stat[]>, required: true },
  previousStats: { type: Array as PropType<Stat[] | null>, default: null },
  showChanges: { type: Boolean, default: false },
  animateOnMount: { type: Boolean, default: false },
},
  setup(__props) {

const props = __props;



// local helper (kept as function for template use)
function getChange(stat: Stat, index: number): number {
  if (!props.previousStats || !Array.isArray(props.previousStats)) return 0;
  const prev = props.previousStats[index];
  if (!prev) return 0;
  return stat.count - prev.count;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.stats, (stat, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "stat-item",
          key: stat.status
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(stat.label), 1),
              (stat.tooltip)
                ? (_openBlock(), _createBlock(LingoTooltipIcon, {
                    key: 0,
                    text: stat.tooltip,
                    placement: "top",
                    class: "info-tooltip",
                    ariaLabel: stat.label
                  }, null, 8, ["text", "ariaLabel"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(stat.count), 1),
              (__props.showChanges && getChange(stat, index) !== 0)
                ? (_openBlock(), _createBlock(LingoBadge, {
                    key: 0,
                    variant: 'pill',
                    tone: 'color',
                    size: 'sm',
                    color: getChange(stat, index) > 0 ? 'success' : 'gray',
                    "data-testid": `badge-${'pill'}-${'color'}-${'sm'}-${'gray'}`
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_Transition, null, {
                          default: _withCtx(() => [
                            _createElementVNode("span", {
                              class: _normalizeClass(["change-arrow", getChange(stat, index) > 0 ? 'arrow-up' : 'arrow-down'])
                            }, [
                              (getChange(stat, index) > 0)
                                ? (_openBlock(), _createElementBlock("svg", _hoisted_9, _hoisted_11))
                                : (_openBlock(), _createElementBlock("svg", _hoisted_12, _hoisted_14))
                            ], 2)
                          ]),
                          _: 2
                        }, 1024),
                        _createElementVNode("span", null, _toDisplayString(Math.abs(getChange(stat, index))), 1)
                      ])
                    ]),
                    _: 2
                  }, 1032, ["color"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", {
              class: "progress-bar-fill",
              style: _normalizeStyle({
              width: stat.percentage + '%',
              backgroundColor: stat.color
            })
            }, null, 4)
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})